/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";

import useApi from "../api";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";


export const useReversalService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();

  async function getReversal(filter: any = null): Promise<IApiResponse<any[] | any>> {
    try {
      const response = await api.post(`/Case/GetAllFormsByFilter`, filter);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getReversalTreeById(id: string): Promise<any> {
    try {
       const response = await api.get(`/TPClient/TreeOption/${id}`);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getReversalById(id: string, isOrigin: boolean): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/Case/GetExternalFormByIdAsync`, {id_case: id, is_Original:isOrigin});
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getReversalImage(id: any): Promise<IApiResponse<any>> {
    try {
      const response = await api.get(`/TPClient/Attachs/${id}`);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getReversalBase64(id: any, encriptograph: string): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/TPClient/Attach/${id}`, encriptograph);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function updateReversal(data: any): Promise<any> {
    try {
     const response = await api.post(`/Case/UpdateExternalFormAsync`, data);
    return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function updateReplaceForm(data: any): Promise<any> {
    try {
      const response = await api.post(`/Case/ChangeQueueAsync`, data);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  
  async function authByRoute(id: any): Promise<any> {
    try {
     const response = await api.get(`/Auth/Token/${id}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function endCaseById(data: any): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/Case/EndCaseAsync`, data);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function saveFormTableChages(data: any): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/Case/SaveAddaAsync`, data);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function saveMultiFaqsTable(data: any): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/Case/BatchSaveAddaAsync`, data);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function updateFaqByUpload(data: any): Promise<IApiResponse<any>> {
    try {
      const response = await api.post(`/Case/ImportSaveAsync`, data);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  return {
    getReversal,
    getReversalTreeById,
    getReversalById,
    updateReversal,
    updateReplaceForm,
    getReversalImage,
    authByRoute,
    endCaseById,
    saveMultiFaqsTable,
    saveFormTableChages,
    updateFaqByUpload,
    getReversalBase64
  };
};
